import { render, staticRenderFns } from "./WorkAreaEdit.vue?vue&type=template&id=79895f3f"
import script from "./WorkAreaEdit.vue?vue&type=script&lang=js"
export * from "./WorkAreaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports